import { t_DataIdentifier, t_DataPointTimeSeries } from '../apiHandler/did-data-retrieval/did-data-retrieval.service';

/**
 *
 * @param identifier1 Single Identifier which should be checked for appearance *
 * @param identifier2 Identifier or array of identifiers to be checked for equality or of containing identifier1 *
 * The function checks, if identifier1 is equal or is contained in identifier2 depending if it´s a single identifier or an array of identifiers. *
 * @returns Boolean Value - True if identifier1 is equal or contained in identifier2. False otherwise
 */
// Overloads
export function dataIdentifierEqual(identifier1: t_DataIdentifier, identifier2: t_DataIdentifier): boolean;
export function dataIdentifierEqual(identifier1: t_DataIdentifier, identifier2: t_DataIdentifier[]): boolean;
// Implementation
export function dataIdentifierEqual(identifier1: t_DataIdentifier, identifier2: t_DataIdentifier | t_DataIdentifier[]): boolean {
    if (Array.isArray(identifier2)) {
        let identifierInArray: boolean = false;
        identifierInArray = identifier2.some((identifier) => {
            return identifier.ecu_id == identifier1.ecu_id && identifier.data_id == identifier1.data_id;
        });
        return identifierInArray;
    } else {
        let ecuIdEqual, dataIdEqual: boolean;
        ecuIdEqual = identifier1.ecu_id == identifier2.ecu_id;
        dataIdEqual = identifier1.data_id == identifier2.data_id;

        return ecuIdEqual && dataIdEqual;
    }
}

export function findIndexOfIdentifierInDataPointTimeseries(searchIdentifier: t_DataIdentifier, dataset?: t_DataPointTimeSeries[]): number {
    let index: number = -1;
    if (dataset == undefined) {
        return index;
    } else {
        index = dataset.findIndex((series) => {
            return series.identifier.ecu_id == searchIdentifier.ecu_id && series.identifier.data_id == searchIdentifier.data_id;
        });
    }
    return index;
}
